import { render, staticRenderFns } from "./recommendFollow.vue?vue&type=template&id=156a104d&scoped=true&"
import script from "./recommendFollow.vue?vue&type=script&lang=js&"
export * from "./recommendFollow.vue?vue&type=script&lang=js&"
import style0 from "./recommendFollow.vue?vue&type=style&index=0&id=156a104d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156a104d",
  null
  
)

export default component.exports